import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function MoVeKI2EAH() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>MoVeKI2EAH</BlockTitle>
          <BlockSubtitle><b>Mo</b>dularer Lehrbaukasten zur <b>Ve</b>rmittlung von <b>KI</b>-Kompetenzen für angewandte Wissenschaften an der <b>E</b>rnst-<b>A</b>bbe-<b>H</b>ochschule Jena</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText>The MoveKI2EAH project was sponsored by the Federal Ministry of Research, Technology and Space (BMFTR) and operated as an internal initiative at the University of Applied Sciences Jena. The primary objective of this project was to modernize the teaching of artificial intelligence subjects at the university level. It seeked to create a series of teaching units that address easily comprehensible topics in AI. These units can be seamlessly integrated into broader teaching modules as required.</BlockText>
        </BlockContent>
      </Block>





      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
        </BlockContent>
        <BlockContent>
          <BlockText><b>Project Start:</b> 01.12.2021</BlockText>
          <BlockText><b>Project End:</b> 01.12.2025</BlockText>
          <BlockText><b>Budget:</b> € 1,98 Mio.</BlockText>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent>
          <BlockSubtitle>Description</BlockSubtitle>
          <BlockText>On December 1, 2021, the university project “Modular Teaching Kit for Imparting AI Competencies for Applied Sciences at the Ernst-Abbe-Hochschule Jena” (MoVeKI2EAH) was launched. This project, funded with 1,974,000 Euros over four years, aims to build competencies in the field of Applied AI and is one of 54 projects financed by the BMBF through the federal-state program “Artificial Intelligence in Higher Education.” As part of the project, six full-time positions for scientific staff will be created, and a High-Performance Computing Cluster will be acquired.
          <br/><br/>
          For Applied AI to be implemented as study content in a practical and needs-based manner, identifying and defining relevant competencies and mapping them to individual disciplines are essential. To achieve this, the project is anchored in various departments at EAH Jena. There will be close collaboration not only in teaching but also through applied research projects. The integration of project staff into application-oriented AI projects enables the practical validation of required competencies, the development and refinement of methods and approaches, and the creation of practical examples and real datasets for teaching. This provides sustainable added value for future teaching in the field of Applied AI at EAH Jena.
          <br/><br/>
          To achieve its objectives, the project team works in an interdisciplinary manner across multiple departments, including Industrial Engineering, Electrical Engineering and Information Technology, Medical Technology and Biotechnology, Business Administration, and Basic Sciences.
          <br/><br/>
          Together with the project staff, teaching modules will be developed based on the defined competencies, and datasets will be prepared accordingly. From this, a certificate course “Applied AI” consisting of three modules will be created for students of EAH Jena. These modules will also cover sociotechnical and ethical aspects of AI. Students will be empowered to identify, assess, and competently contribute to shaping AI-induced change, with relevant competencies in ethics and AI being identified and incorporated into teaching.
          <br/><br/>
          All teaching units and prepared data collections developed within the framework of the project will be made available as Open Educational Resources (OER) and Open Data.
          </BlockText>
        </BlockContent>
      </Block>

      {/* <Block colorTheme="dark">
        <BlockContent width="100%">
          <BlockSubtitle>Task Breakdown</BlockSubtitle>
          <BlockText>WIP</BlockText>
        </BlockContent>
      </Block> */}


      <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent width="10%" textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open('https://www.eah-jena.de/moveki2eah/informationen')}>Projectpage</BlockButton>
        </BlockContent>
      </Block>



      <Footer/>
    </div>
  );
}

export default MoVeKI2EAH;